<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
    items: Array<{
        title: string,
        desc: string,
    }>
}>();
const featureStyles = [
  { state: 'first', vairant: 'primary' },
  { state: 'second', vairant: 'white' },
  { state: 'first', vairant: 'secondary' },
  { state: 'first', vairant: 'secondary' },
  { state: 'first', vairant: 'primary' },
  { state: 'second', vairant: 'white' },
] as const;
</script>

<template>
    <SectionsBase id="features" class="container">
      <ChipsDivider>ویژگی‌ها</ChipsDivider>
      <h2>{{ props.title }}</h2>
      <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
      <div class="mt-8 lg:mt-24 max-w-full flex flex-col gap-7">
        <div class="w-full flex-center flex-col lg:flex-row gap-7">
          <LazyCardsFeature
            v-for="feature, index in props.items.slice(0, 3)"
            :key="feature.title"
            type="Secondary"
            :state="featureStyles.slice(0, 3)[index]?.state"
            :vairant="featureStyles.slice(0, 3)[index]?.vairant"
            :class="index === 1 && 'lg:-mt-30'"
            data-aos="fade-up" 
            data-aos-duration="1000"
          >
            <div class="flex flex-col items-center gap-7">
              <h3>{{ feature.title }}</h3>
              <p v-html="feature.desc" />
            </div>
          </LazyCardsFeature>
        </div>
        <div class="w-full flex-center flex-col lg:flex-row gap-7">
          <LazyCardsFeature
            v-for="feature, index in props.items.slice(3)"
            :key="feature.title"
            type="Secondary"
            :state="featureStyles.slice(3)[index]?.state"
            :vairant="featureStyles.slice(3)[index]?.vairant"
            :class="[
              index === 0 && 'order-2 lg:order-1',
              index === 1 && 'order-1 lg:order-2 lg:-mt-30',
              index === 2 && 'order-3',
            ]"
            data-aos="fade-up" 
            data-aos-duration="1000"
            :data-aos-delay="index % 3 * 300"
          >
            <div class="flex flex-col items-center gap-7">
              <h3>{{ feature.title }}</h3>
              <p v-html="feature.desc" />
            </div>
          </LazyCardsFeature>
        </div>
      </div>
    </SectionsBase>
</template>